export default __webpack_public_path__ + "static/media/Path of Ahriman.013e1288.jpg";